//@ts-ignore
// @ts-nocheck
import { applySnapshot, cast, getSnapshot, types } from "mobx-state-tree";
import { determineNoOfTeachers } from "./utils/misc";

export const LessonScheduleStore = types
  .model("LessonScheduleStore", {
    lessonDays: types.optional(types.array(types.string), []),
    lessonHours: types.optional(types.number, 1),
    lessonTime: types.optional(types.string, "4:00 PM"),
    lessonDuration: types.optional(types.number, 4),
    lessonUrgency: types.optional(types.string, ""),
    lessonPlan: types.optional(types.string, ""),
    hourlyRate: types.optional(types.array(types.number), []),
    extraStudentFx: types.optional(types.number, 0.2),
    premiumFx: types.optional(types.number, 1.4),
    teacherKind: types.optional(types.string, ""),
  })
  .views((self) => {
    function getSplitRequest(childDetails) {
      const _data = determineNoOfTeachers(childDetails);
      if (self.teacherKind) {
        return _data.teacherSplitOptions[self.teacherKind];
      }
      return [];
    }
    return {
      splitRequests(childDetails) {
        return getSplitRequest(childDetails);
      },
      get fullData() {
        return getSnapshot(self);
      },
      numberOfTeachers(childDetails) {
        let r = getSplitRequest(childDetails);
        return r.length;
      },
    };
  })
  .actions((self) => {
    return {
      updateFields(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
      updateField(key, value) {
        if (Array.isArray(value)) {
          self[key] = cast(value);
        } else {
          self[key] = value;
        }
      },
    };
  });

export default LessonScheduleStore;
